import React, { useState } from "react";
import styles from "./style.module.css"

interface EmailModalProp {
  showModal: string;
  closeModal: any
}

const PaymentSuccess: React.FC<EmailModalProp> = ({ showModal, closeModal }) => {

  return (
    <div className={`modal fade ${showModal ? showModal : ''}`}
      style={showModal ? { display: "block" } : { display: "none" }}
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" onClick={() => closeModal("")} aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className={styles.EsimModal}>
              <p>Thanks a bunch!! <br/><br/>We value your business and look forward to serving you again. An confirmation email will be sent shortly.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PaymentSuccess